import definitions from "../../definitions";
import {iswebfont, locale, resizeLabelToFitText, sensitiveUpperCase} from "../../utils";
import TextFormat from "../TextFormat";
import QuestTrackerPopup from "./QuestTrackerPopup";

export default class QuestTrackerDefaultPopup extends QuestTrackerPopup {
    /**
     * @param {string} type
     * @param {Quest} quest
     * @param {string} [message=""]
     * @param {PIXI.Texture} [icon=PIXI.Texture.EMPTY]
     */
    constructor(type, quest, message = "", icon = PIXI.Texture.EMPTY, iconScale = 1) {
        super(type, quest);

        this._message = message.trim();
        this._iconTexture = icon;

        this._nameLabel = null;
        this._descriptionLabel = null;
        this._icon = null;
        this._iconScale = iconScale;
    }

    init() {
        super.init();

        let name = locale(this._quest.name);
        if (this._message.length > 0) {
            name += " - " + this._message;
        }
        if (!iswebfont()) {
            this._nameLabel = new PIXI.BitmapText(sensitiveUpperCase(name), {
                fontName: "Alghera Pro",
                fontSize: 26,
                align: "left",
                tint: 0x000000,
                maxWidth: 360
            });
        } else {
            this._nameLabel = new PIXI.Text(sensitiveUpperCase(name), {
                fontFamily: "FredFredBurger",
                fontSize: 26,
                align: "left",
                fill: 0x0,
                wordWrap: true,
                wordWrapWidth: 360
            });
        }
        this._nameLabel.position.set(86, !iswebfont() ? 18 : 12);
        //this._nameLabel.anchor.set(0, 1);
        this.addChild(this._nameLabel);
        //resizeLabelToFitText(this._nameLabel, 320); 

        const text = TextFormat.formatTextVar(locale(this._quest.description), definitions.TEXT_FORMAT_VAR.TARGET, this._quest.target);
        if (!iswebfont()) {
            this._descriptionLabel = new PIXI.BitmapText(text, {
                fontName: "Alghera Pro",
                fontSize: 20,
                align: "left",
                tint: 0x702311,
                maxWidth: 320
            });
        } else {
            this._descriptionLabel = new PIXI.Text(text, {
                fontFamily: "FredFredBurger",
                fontSize: 20,
                align: "left",
                fill: 0x702311,
                wordWrap: true,
                wordWrapWidth: 320
            });
        }
        //this._descriptionLabel.position.set(86, !iswebfont() ? 50 : 46);
        this._descriptionLabel.x = 86;
        this._descriptionLabel.y = this._nameLabel.y + this._nameLabel.height + (!iswebfont() ? 10 : 2);
        this._descriptionLabel.anchor.set(0, 0);
        this.addChild(this._descriptionLabel);
        //resizeLabelToFitText(this._descriptionLabel, 320);


        const bottomPadding = 45;
        this._frame.height = this._nameLabel.height + this._descriptionLabel.height + bottomPadding;

        this._icon = new PIXI.Sprite(this._iconTexture);
        this._icon.position.set(445, 42);
        this._icon.anchor.set(0.5);
        this._icon.scale.set(this._iconScale);
        this.addChild(this._icon);
    }

    /**
     * @return {string}
     */
    get message() {
        return this._message;
    }
}